/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Action_InviteInputs */

const cs_gdpr_action_invite = /** @type {(inputs: Gdpr_Action_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozvánka`)
};

const en_gdpr_action_invite = /** @type {(inputs: Gdpr_Action_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invited`)
};

/**
* | output |
* | --- |
* | "Invited" |
*
* @param {Gdpr_Action_InviteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_action_invite = /** @type {((inputs?: Gdpr_Action_InviteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Action_InviteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_action_invite(inputs)
	return cs_gdpr_action_invite(inputs)
});